export default __webpack_public_path__ + "static/media/folder-open-black.bff1f2af.svg";